import React from "react";
import RefreshIcon from "../../../../img/refresh_selected.svg";

const LoadMorePagination = ({
  page,
  setPage,
  totalPages,
  isLoadingMore,
  style,
}) => {
  const hasMore = page + 1 < totalPages;
  const shouldShowControl = hasMore || isLoadingMore;

  const handleLoadMore = () => {
    if (hasMore && !isLoadingMore) {
      setPage(page + 1);
    }
  };

  return (
    <div className="load-more-controls" onClick={handleLoadMore} style={style}>
      {shouldShowControl && (
        <>
          <div className="refresh-btn" title="Refresh">
            <img
              src={RefreshIcon}
              alt="Refresh"
              className={`refresh-icon ${isLoadingMore ? "spinning" : ""}`}
            />
          </div>

          <span className={`load-more-btn ${isLoadingMore ? "loading" : ""}`}>
            {isLoadingMore ? "Loading..." : "Load More"}
          </span>
        </>
      )}
    </div>
  );
};

const ResultsCounter = ({
  page,
  totalCount,
  pageSize,
  currentCount: providedCurrentCount,
}) => {
  if (totalCount === 0) return null;

  const currentCount =
    providedCurrentCount !== undefined
      ? providedCurrentCount
      : Math.min((page + 1) * pageSize, totalCount);

  return (
    <div className="results-counter">
      <span>
        Showing {currentCount} out of {totalCount} results
      </span>
    </div>
  );
};

export { ResultsCounter };
export default LoadMorePagination;
